export default __webpack_public_path__ + "media/images/how-it-works-bg-2b8490e2edf48a1508f6c92b33182555.jpg";